<ng-template #longContent let-modal>
  <div class="modal-header">
    <h3 class="modal-title">
      {{ 'verificationPortal.listSignaturesPage.modalTitle' | translate }}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body container">
    <div class="modal-body-header">
      <div class="contract-detail-information d-flex justify-content-between">
        <div class="detail-name d-flex">
          <div class="doc-name">{{envelopeInfo.title}}</div>
        </div>
      </div>
      <div class="mb-3 mt-2">
        <span>
          <b>
            {{ 'verificationPortal.listSignaturesPage.verificationCode' | translate }}
          </b>
        </span>
        <span>
          {{ envelopeInfo.verificationCode }}
        </span>
      </div>
      <div>
        <cdx-alert [options]="setAlertOptions(0)" [alertTemplate]="success" *ngIf="envelopeInfo.status === 2 || (envelopeInfo.status === 10 && envelopeInfo.timeStamp === 1)">
          <ng-template #success> 
            <div class="row">{{ 'verificationPortal.listSignaturesPage.documentSigned' | translate }}</div>
          </ng-template>
        </cdx-alert>
        <cdx-alert [options]="setAlertOptions(1)" [alertTemplate]="warning" *ngIf="envelopeInfo.status !== 2 && envelopeInfo.status !== 10">
          <ng-template #warning> 
            <div class="row"> {{ 'verificationPortal.listSignaturesPage.documentNotSigned' | translate }}</div>
          </ng-template>
        </cdx-alert>
      </div>
    </div>
    <div class="mt-4 mb-2" *ngIf="envelopeInfo.status == 2 || envelopeInfo.status == 10">
      <span class="title" *ngIf="envelopeInfo.authorizers.length >= 1">
        {{ 'verificationPortal.listSignaturesPage.authorizers' | translate }}
      </span>
      <div class="signature-list" *ngIf="envelopeInfo.authorizers.length >= 1"> 
        <div class="p-1">
          <div class="signature-card row p-3 mb-2" *ngFor="let authorizer of envelopeInfo.authorizers">
            <div class="col-lg-8">
              <div class="signature__role">
                <fa-icon class="mr-2" [icon]="['far','user']"></fa-icon>
                <span class="signature__user-name">
                  {{ authorizer.name }}
                </span>
              </div>
              <div class="ml-4">
                <div *ngIf="isShowSSN(authorizer.ssn)">
                  <span class="label mr-1">
                    <b>{{ isShowSSNName(authorizer.ssn) }}
                    </b>
                  </span>
                  <span class="value">
                    {{ isShowSSNMask(authorizer.ssn) }}
                  </span>
                </div>
                <div class="signature__user-date mb-1">
                  <span class="mr-1">
                    <b>{{ 'verificationPortal.listSignaturesPage.authorizationDate' | translate }}:</b></span>
                  <span class="value">
                    {{ authorizer.date | datetimeFormatLanguage:
                    datetimeFormatLanguageEnum.datetimeUtcFormatted }}
                  </span>
                </div>
                <div>
                  <span class="label"><b>{{'mail' | translate | titlecase}}: </b></span>
                  <span class="value">{{ authorizer.mail }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span class="title">
        {{ 'verificationPortal.listSignaturesPage.signatures' | translate }}
      </span>
      <div class="signature-list ">
        <div class="p-2">
          <div class="signature-card row p-3 mb-2" *ngFor="let signer of envelopeInfo.subscriptions">
            <div class="col-lg-7">
              <div class="signature__role">
                <fa-icon class="mr-2" [icon]="['far','user']"></fa-icon>
                <span class="signature__user-name">
                  {{ signer.signatoryName }}
                </span>
              </div>
              <div class="ml-4">
                <div *ngIf="isShowSSN(signer.signatorySsn)">
                  <span class="label mr-1">
                    <b>{{ isShowSSNName(signer.signatorySsn) }}
                    </b>
                  </span>
                  <span class="value">{{ isShowSSNMask(signer.signatorySsn) }}</span>
                </div>
                <div class="signature__user-date mb-2">
                  <fa-icon class="mr-1" style="color:#0BC07E;" [icon]="['fas','check-circle']"></fa-icon>
                  <span class="value">
                    {{ signer.signatureDate | datetimeFormatLanguage:
                    datetimeFormatLanguageEnum.datetimeUtcFormatted }}
                  </span>
                </div>
                <div class="signature__geolocation" *ngIf="!signer.isDigital && signer.isGeolocation">
                  <span class="label">
                    <b>
                      {{ 'verificationPortal.listSignaturesPage.geolocation' | translate }}
                    </b>
                  </span>
                  <span class="value">
                    {{ 'verificationPortal.listSignaturesPage.latitude' | translate }}
                    : {{ signer.latitude }}
                  </span>
                  <span class="value">
                    {{ 'verificationPortal.listSignaturesPage.longitude' | translate }}
                    : {{ signer.longitude }}
                  </span>
                </div>
                <br *ngIf="!signer.isGeolocation">
                <div *ngIf="!signer.isDigital">
                  <span class="label"><b>IP: </b></span>
                  <span class="value">{{ signer.signatoryIp }}</span>
                </div>
                <div>
                  <span class="label">
                    <b>{{ 'verificationPortal.listSignaturesPage.type' | translate }}: </b>
                  </span>
                    <span class="value">{{ signer.signatoryTypeRoleIsDefault ? (signer.signatoryTypeRoleName | translate | titlecase) : (signer.signatoryTypeRoleName) }}</span>
                </div>
                <div>
                  <span class="label">
                    <b>{{ 'reports.envelopePrintReport.signatureAs' | translate }}: </b>
                  </span>
                  <span class="value">{{ getSignatureTypeKey(signer) | translate }}</span>
                </div>
                <div>
                  <span class="label">
                    <b>{{'mail' | translate | titlecase}}: </b>
                  </span>
                  <span class="value">{{ signer.signatoryMail }}</span>
                </div>
                <div class="signature__evidencies-hash" *ngIf="signer.signatureHash">
                  <span class="label">
                    <b>
                      {{ 'verificationPortal.listSignaturesPage.evidenceHash' | translate }}
                    </b>
                  </span>
                  <span class="value">{{ signer.signatureHash }}</span>
                </div>
                <img src="assets/img/assintaura-icp.png" width="36%" style="margin-top: 10px;" *ngIf="signer.isIcpBrasil" />
                <img class="signature__selfie" *ngIf="signer.signatorySelfieBase64"
                     [src]="signer.signatorySelfieBase64"
                     [alt]="'verificationPortal.listSignaturesPage.livenessSelfie' | translate"
                     [title]="'verificationPortal.listSignaturesPage.livenessSelfie' | translate">
              </div>
            </div>
            <div class="signature__img col-lg-5"
                 [ngClass]="signer.signatorySelfieBase64 ? 'align-self-end' : 'align-self-center'"
                 *ngIf="signer.signatoryRubricBase64">
              <img [src]="signer.signatoryRubricBase64" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-between {{envelopeInfo.status === 10 && envelopeInfo.timeStamp === 1 || portalType == 1 ? 'float-right' : ''}}">
      <div *ngIf="!(envelopeInfo.status === 10 && envelopeInfo.timeStamp === 1) && portalType == 0" ngbDropdown class="d-inline-block mt-2">
        <button class="cdx-button cdx-button--secondary cdx-button--outline" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
          <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','download']"></fa-icon>
          <span class="">{{ 'verificationPortal.listSignaturesPage.downloadBtn' | translate }}</span>
        </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="max-width: unset;">
            <button ngbDropdownItem (click)="downloadOriginalFile()">
              {{'verificationPortal.listSignaturesPage.btnDownloadOriginal' | translate }}
            </button>
            <button ngbDropdownItem (click)="downloadSignedFile()">
              {{'verificationPortal.listSignaturesPage.btnDownloadSigned'| translate}}
            </button>
            <button ngbDropdownItem (click)="downloadPrintingFile(true)">
              {{'verificationPortal.listSignaturesPage.btnDownloadToPrint' | translate }}
            </button>
            <button ngbDropdownItem (click)="downloadPrintingFile(false)">
              {{'verificationPortal.listSignaturesPage.btnDownloadToPrintNoStamp' | translate }}
            </button>
          </div>
      </div>
      <div class="d-inline-block mt-2">
        <button (click)="closeModalList()" class="cdx-button cdx-button--primary" id="btn-finish">
          <span>{{ 'verificationPortal.listSignaturesPage.finishBtn' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
